var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGustoMark = function SvgGustoMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "gusto-adc51a75b78f1cea2784cbe358c1e4cf3cd55bde6d93ba52bd9122c31109331b")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-1210.000000, -6319.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1188.000000, 6299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gusto-adc51a75b78f1cea2784cbe358c1e4cf3cd55bde6d93ba52bd9122c31109331b",
    transform: "translate(22.757143, 20.228571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0642857,11.6314286 L13.0642857,0.252857143 L9.94571429,0.252857143 L9.94571429,1.01142857 C8.93428571,0.337142857 7.75428571,5.61455644e-16 6.49,5.61455644e-16 C2.95,5.61455644e-16 7.48607525e-16,2.95 7.48607525e-16,6.57428571 C7.48607525e-16,10.1985714 2.95,13.1485714 6.49,13.1485714 C7.75428571,13.1485714 8.93428571,12.8114286 9.94571429,12.1371429 L9.94571429,12.39 C9.94571429,14.3285714 8.42857143,15.8457143 6.49,15.8457143 C5.81571429,15.8457143 5.22571429,15.6771429 4.63571429,15.34 L3.11857143,18.0371429 C4.13,18.6271429 5.31,18.9642857 6.49,18.9642857 C10.1142857,18.9642857 13.0642857,16.0142857 13.0642857,12.39 C13.0642857,12.2214286 13.1485714,11.8 13.0642857,11.6314286 Z M6.49,10.03 C4.63571429,10.03 3.03428571,8.51285714 3.03428571,6.57428571 C3.03428571,4.63571429 4.55142857,3.11857143 6.49,3.11857143 C8.42857143,3.11857143 9.94571429,4.63571429 9.94571429,6.57428571 C9.94571429,8.42857143 8.42857143,10.03 6.49,10.03 Z",
    id: "Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGustoMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gusto-mark.a1353cbd.svg";
export { ForwardRef as ReactComponent };